const t = "data:image/svg+xml,%3csvg%20width='1'%20height='1'%20viewBox='0%200%201%201'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%20xmlns:xlink='http://www.w3.org/1999/xlink'%20/%3e";
export {
  t as default
};
//# sourceMappingURL=icon-blank.svg.js.map
